
import { ProductosContext } from "context/productos_context";
import { useContext } from "react";
import { BsArrowDownRightCircleFill } from "react-icons/bs";


function Categorias({ noPerspectivas, noImpacto, noCotidiano,reorden }) {
    const {orden,setOrden} = useContext(ProductosContext)
    return (
        <div className='' >
            <div className='d-lg-flex justify-content-between w-100 mb-5'>
                <div className={orden === "Perspectiva"? 'border-blue d-flex flex-column justify-items-center align-items-center ':'border-blue d-flex flex-column justify-items-center align-items-center '}>
                    <div className='background-image1 text-white cta-news' onClick={()=>{
                        reorden('Perspectiva')
                        setOrden('Perspectiva')
                    }}>
                        <div className='d-flex flex-column h-100 border '>
                            <div className='p-3 text-bold text-medium'>Perspectiva Estratégica</div>
                            <div className="col"></div>
                            <div className='d-flex align-items-end p-3'>
                                <div>{noPerspectivas} Entradas</div>
                                <div className="col"></div>
                                <div className="text-medium"><BsArrowDownRightCircleFill /></div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-3 text-center">Artículos con análisis profundo, opinión fuerte o implicaciones económicas/políticas relevantes</div>
                </div>
                <div className={orden === "Impacto"? 'border-blue d-flex flex-column justify-items-center align-items-center':'border-blue d-flex flex-column justify-items-center align-items-center '}>
                    <div className='background-image2 cta-news' onClick={()=>{
                        reorden('Impacto')
                        setOrden('Impacto')
                    }}>
                        <div className='d-flex flex-column h-100 text-white'>
                            <div className='p-3 text-bold text-medium'>Impacto y transformación</div>
                            <div className="col"></div>
                            <div className='d-flex align-items-end p-3'>
                                <div>{noImpacto} Entradas</div>
                                <div className="col"></div>
                                <div className="text-medium"><BsArrowDownRightCircleFill /></div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-3 text-center">Vínculos clave entre minería, sectores y políticas, con enfoque constructivo.</div>
                </div>
                <div className={orden === "Mineria"? 'border-blue d-flex flex-column justify-items-center align-items-center':'border-blue d-flex flex-column justify-items-center align-items-center '}>
                    <div className='background-image3 cta-news' onClick={()=>{
                        reorden('Mineria')
                        setOrden('Mineria')
                    }}>
                        <div className='d-flex flex-column h-100 text-white'>
                            <div className='p-3 text-bold text-medium'>Minería cotidiana</div>
                            <div className="col"></div>
                            <div className='d-flex align-items-end p-3'>
                                <div>{noCotidiano} Entradas</div>
                                <div className="col"></div>
                                <div className="text-medium"><BsArrowDownRightCircleFill /></div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-3 text-center">Contenido accesible para informar, educar y desmitificar la minería.</div>
                </div>
            </div>
        </div>
    )
}

export default Categorias